import { render, staticRenderFns } from "./RutePenyebranganAdd.vue?vue&type=template&id=6088ee20&scoped=true"
import script from "./RutePenyebranganAdd.vue?vue&type=script&lang=js"
export * from "./RutePenyebranganAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6088ee20",
  null
  
)

export default component.exports